/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayDraftReq
 */
export interface AdminEbayDraftReq {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof AdminEbayDraftReq
     */
    aspects?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {number}
     * @memberof AdminEbayDraftReq
     */
    buyerShipping?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayDraftReq
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayDraftReq
     */
    categoryName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayDraftReq
     */
    condition?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayDraftReq
     */
    conditionDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayDraftReq
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEbayDraftReq
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayDraftReq
     */
    title: string;
}

export function AdminEbayDraftReqFromJSON(json: any): AdminEbayDraftReq {
    return AdminEbayDraftReqFromJSONTyped(json, false);
}

export function AdminEbayDraftReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayDraftReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aspects': !exists(json, 'aspects') ? undefined : json['aspects'],
        'buyerShipping': !exists(json, 'buyerShipping') ? undefined : json['buyerShipping'],
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'categoryName': !exists(json, 'categoryName') ? undefined : json['categoryName'],
        'condition': !exists(json, 'condition') ? undefined : json['condition'],
        'conditionDescription': !exists(json, 'conditionDescription') ? undefined : json['conditionDescription'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'title': json['title'],
    };
}

export function AdminEbayDraftReqToJSON(value?: AdminEbayDraftReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aspects': value.aspects,
        'buyerShipping': value.buyerShipping,
        'categoryId': value.categoryId,
        'categoryName': value.categoryName,
        'condition': value.condition,
        'conditionDescription': value.conditionDescription,
        'description': value.description,
        'price': value.price,
        'title': value.title,
    };
}

